import { types } from "../../../types";

const savedEnterpriseId = localStorage.getItem("active_enterprise_id")
    ? parseInt(localStorage.getItem("active_enterprise_id"), 10)
    : null;

const bootConfigs =
    typeof window !== "undefined" && window.__APP_BOOT__ ? window.__APP_BOOT__ : {};

const initialState = {
    tiny_name: "",
    update_test_db_log: [],
    backup_list: [],
    selected_enterprise_id: savedEnterpriseId,
    ...bootConfigs,
};

export const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.setConfig:
            return {
                ...state,
                ...action.payload,
            };
        case types.setActiveEnterprise:
            return {
                ...state,
                selected_enterprise_id: action.payload,
            };
        case types.setUpdateDBTestLOG:
            return {
                ...state,
                update_test_db_log: action.payload,
            };
        case types.setBackupList:
            return {
                ...state,
                backup_list: action.payload,
            };

        default:
            return state;
    }
};
